import { useStore } from '../../lib/hooks/useStore';
import { ReceiptLayout } from './receipt-layout';
import style from './style.module.scss';

/**
 * ReceiptPrint Component
 *
 * A component that renders a receipt layout optimized for printing.
 * The content is hidden on screen and only visible when printing via CSS media queries.
 */
export default function ReceiptPrint() {
	const {
		uiStore: { receiptMounted },
		receiptStore: { receiptData },
	} = useStore();

	// Don't render anything if receipt is not mounted or no receipt data
	if (!receiptMounted || !receiptData) {
		return null;
	}

	return (
		<div className={style.wrapper}>
			<ReceiptLayout data={receiptData} />
		</div>
	);
}
